import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import moment from 'moment'
import ChartLine from '../../../components/charts/ChartLine'
import ChartLineSkeleton from '../../../components/skeletons/ChartLineSkeleton'
import { ChartLineThemes } from '../../../components/charts/types/ChartLine'
import { formatCurrency } from '../../../utils/Helpers'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { GET_REVENUE_BY_MONTH } from '../../../queries/factory'

type BucketTypes = {
  key_as_string: string,
  key: number,
  doc_count: number,
  total : {
    value : number
  }
}

type Series = {
  name: string
  data: number[]
}

const MounthRevenue = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const categories: Array<string> = []
  const series: Array<Series> = [
    {
      name: 'Receita',
      data: []
    }
  ]

  const [getData, { loading, data, networkStatus }] = useLazyQuery(
    GET_REVENUE_BY_MONTH, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const { factory } = filters

    const orderCreatedAt: any = {
      initialDate: `01-01-${moment(filters.orderCreatedAt?.initialDate).year()}`,
      finalDate: `31-12-${moment(filters.orderCreatedAt?.finalDate).year()}`,
      format: 'dd-MM-yyyy||/yyyy'
    }
    getData({
      variables: { filters: { factory, orderCreatedAt } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartLineSkeleton />
  if (loading || !data) return <ChartLineSkeleton />
  if (!data.aggregation.aggregations.months) return <p>No data found</p>

  const { buckets } = data?.aggregation?.aggregations?.months

  series.map(serie => {
    buckets.map((bucket: BucketTypes) => {
      serie.data.push(bucket.total.value)
    })
  })

  buckets.map((bucket: BucketTypes) => {
    categories.push(moment(bucket.key_as_string).format('MM/DD/YYYY'))
  })

  const options = {
    chart: {
      id: 'orders-total-history'
    },
    xaxis: {
      categories,
      type: 'date',
      labels: {
        formatter: (value: Date) => {
          return moment(value).format('DD-MM-YYYY')
        }
      }
    },
    yaxis: {
      categories,
      labels: {
        formatter: (value: number) => {
          return formatCurrency(value)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Evolução mês vs mês</Typography>
    <ChartLine options={options} series={series} theme={ChartLineThemes.threecolors} height={320} type="area" />
  </Paper>
}

export default MounthRevenue
